// extracted by mini-css-extract-plugin
export default {"btn":"SearchBox_btn__DYEAs","input":"SearchBox_input__Y2uGE","custom_select":"SearchBox_custom_select__Xtk1J","custom_select_mob":"SearchBox_custom_select_mob__7WY6z"};